import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import LiveTbCols from "../LiveTbCols";

const MemberCheckinsLog = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  allDatas,
  setAllDatas,
  userInfoData,
  callFunction,
}) => {
  const {
    memberCheckinsLog,
    memberCheckinsLogError,
    memberCheckinsLogLoading,
  } = useSelector((state) => state.live);

  useEffect(() => {
    if (
      !memberCheckinsLogLoading &&
      !memberCheckinsLogError &&
      memberCheckinsLog?.status &&
      memberCheckinsLog?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: memberCheckinsLog.data,
        pagination:
          memberCheckinsLog?.pagination?.length > 0
            ? memberCheckinsLog.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: [],
        pagination: [],
      }));
    }
  }, [memberCheckinsLogLoading, memberCheckinsLogError, memberCheckinsLog]);

  return (
    <LiveTbCols
      from="member_checkins"
      userInfoData={userInfoData}
      allDatas={allDatas}
      isPage={isPage}
      setIsPage={setIsPage}
      pageLimit={pageLimit}
      setPageLimit={setPageLimit}
      callFunction={callFunction}
      isLoading={memberCheckinsLogLoading}
    />
  );
};

export default MemberCheckinsLog;
